// import React, { useEffect, useRef, useState } from 'react'
// import './styles.css'
// import SidebarChat from './components/Sidebar'
// import ChatWindow from './components/ChatWindow'
// import { request } from '../../share/request'
// import { getCurrentUser } from '../../share/getProfile'
// import { base_url, domain, linkPath } from '../../share/helper'
// import { io } from 'socket.io-client'
// import heic2any from 'heic2any'
// import { Input } from 'antd'
// export default function MyMessageChat() {
//   const [user, setUser] = useState(getCurrentUser())
//   const [allUsers, setAllUsers] = useState([])
//   const [chatTarget, setChatTarget] = useState(null)
//   const [messages, setMessages] = useState([])
//   const [currentRoomId, setCurrentRoomId] = useState(null)
//   const [bufferedMessages, setBufferedMessages] = useState({})
//   const [messageText, setMessageText] = useState('')
//   const [unreadCounts, setUnreadCounts] = useState({})
//   const [recentChats, setRecentChats] = useState([])
//   const [typing, setTyping] = useState(false)
//   const [isConverting, setIsConverting] = useState(false)
//   const [mobileSearchQuery, setMobileSearchQuery] = useState('')
//   const [isMobile, setIsMobile] = useState(false)
//   // presence: store separate sets for ids and usernames
//   const [presence, setPresence] = useState({ ids: new Set(), names: new Set() })

//   const socketRef = useRef(null)
//   const messagesEndRef = useRef(null)
//   const typingTimeoutRef = useRef(null)
//   const userRef = useRef(user)
//   const chatTargetRef = useRef(chatTarget)
//   const currentRoomIdRef = useRef(currentRoomId)

//   function extractId(u) {
//     if (!u) return null
//     const maybe = u.id || u.user_id || u.userId || u.staff_id || u.staffid || u.staffId
//     const n = Number(maybe)
//     if (Number.isFinite(n) && n > 0) return n
//     if (u.username) {
//       const nx = Number(u.username)
//       if (Number.isFinite(nx) && nx > 0) return nx
//     }
//     return null
//   }

//   function computeRoomId(a, b) {
//     const ai = Number(a)
//     const bi = Number(b)
//     if (!Number.isFinite(ai) || !Number.isFinite(bi)) return null
//     const low = Math.min(ai, bi)
//     const high = Math.max(ai, bi)
//     return (low * 1000000) + high
//   }
  
//   function getPreviewFromMessage(msg) {
//     try {
//       if (!msg) return ''
//       // message may be stringified JSON with { files: [...], caption }
//       let body = null
//       if (typeof msg.message === 'string') {
//         try { body = JSON.parse(msg.message) } catch(e) { body = msg.message }
//       } else if (msg.message && typeof msg.message === 'object') {
//         body = msg.message
//       } else if (typeof msg === 'string') {
//         try { body = JSON.parse(msg) } catch(e) { body = msg }
//       } else if (msg && typeof msg === 'object' && (msg.files || msg.caption)) {
//         body = msg
//       }

//       if (body && typeof body === 'object') {
//         const files = Array.isArray(body.files) ? body.files : (Array.isArray(body.attachments) ? body.attachments : null)
//         const caption = body.caption || body.text || body.caption_text || ''
//         if (caption && String(caption).trim()) return String(caption).trim()
//         if (files && files.length) {
//           // prefer image filename for preview
//           const first = files[0]
//           try {
//             const fname = first.originalName || first.filename || first.name || (first.url ? (first.url.split('/').pop()) : null)
//             if (files.length === 1) return fname || 'Sent a file'
//             return `Sent ${files.length} files${fname ? ` — ${fname}` : ''}`
//           } catch(e) { return `Sent ${files.length} files` }
//         }
//       }

//       // fallback: plain message text fields
//       return (msg && (msg.message || msg.text || msg.body)) ? String(msg.message || msg.text || msg.body) : ''
//     } catch(e) { return '' }
//   }

//   function cacheMessagesForRoom(roomId, msgs) {
//     try { if (!roomId) return; localStorage.setItem(`chat_cache_room:${String(roomId)}`, JSON.stringify(msgs || [])) } catch(e){}
//   }
//   function loadCachedMessages(roomId) {
//     try { if (!roomId) return []; const raw = localStorage.getItem(`chat_cache_room:${String(roomId)}`); if (!raw) return []; const parsed = JSON.parse(raw); return Array.isArray(parsed) ? parsed : [] } catch(e){ return [] }
//   }

//   // SOCKET URL heuristics
//   let SOCKET_URL = (base_url || '').replace(/\/api\/?$/,'') || window.location.origin
//   try { const host = domain ? new URL(domain).hostname : null; if (host === 'localhost' || host === '127.0.0.1') SOCKET_URL = `${window.location.protocol}//${host}:8084` } catch(e){}

//   useEffect(() => { userRef.current = user }, [user])
//   useEffect(() => { chatTargetRef.current = chatTarget }, [chatTarget])
//   useEffect(() => { currentRoomIdRef.current = currentRoomId }, [currentRoomId])

//   // fetch rooms/unread counts to populate sidebar badges
//   const loadRooms = async () => {
//     try {
//       const res = await request('messagechat/rooms', 'get', {})
//       if (res && res.success && Array.isArray(res.rooms)) {
//         const map = {}
//         res.rooms.forEach(r => {
//           if (r && r.other) map[String(r.other)] = Number(r.unread || 0)
//         })
//         setUnreadCounts(map)
//         try {
//           const rc = res.rooms.map(r => {
//             const ru = r.user || {}
//             const avatar = ru.avatar || ru.image || ru.photo || null
//             return ({ room: r.room, other: r.other, unread: r.unread || 0, lastMessagePreview: getPreviewFromMessage({ message: r.lastMessagePreview }), time: r.time || null, user: Object.assign({}, ru, { avatar }) })
//           })
//           setRecentChats(rc)
//         } catch(e) { console.warn('populate recentChats error', e) }
//       }
//     } catch (e) { console.warn('load rooms/unread error', e) }
//   }

//   useEffect(() => { loadRooms() }, [])

//   // load user list for sidebar
//   useEffect(() => {
//     let mounted = true
//     ;(async () => {
//       try {
//         const me = userRef.current || getCurrentUser()
//         const params = new URLSearchParams({})
//         if (me && me.org_code) params.append('org_code', String(me.org_code))
//         const res = await request(`lettersjoiner?${params.toString()}`, 'get', {})
//         if (mounted && res) {
//           if (res.api_server_list_joiner && Array.isArray(res.api_server_list_joiner)) {
//             const mapped = res.api_server_list_joiner.map(item => {
//               const rawImage = item.image || null
//               let image_url = null
//               try {
//                 if (rawImage && (String(rawImage).startsWith('http://') || String(rawImage).startsWith('https://'))) image_url = rawImage
//                 else if (rawImage && String(rawImage).startsWith('/')) image_url = linkPath + String(rawImage).replace(/^\//, '')
//                 else if (rawImage) image_url = linkPath.endsWith('/') ? linkPath + rawImage : linkPath + '/' + rawImage
//               } catch(e) { image_url = rawImage }
//               return {
//                 id: item.id,
//                 username: item.staff_id_number || item.username || '',
//                 fullname: item.staffname_kh1 || item.staffname_en || item.fullname || '',
//                 staffname_eng: item.staffname_en || '',
//                 position: item.position_kh || item.position_en || '',
//                 department_name: item.department_name || '',
//                 image: rawImage || null,
//                 avatar: image_url
//               }
//             })
//             setAllUsers(mapped)
//             try { console.debug('MyMessageChat: loaded allUsers count', mapped.length, mapped.slice(0,3)) } catch(e){}
//           } else if (Array.isArray(res)) {
//             setAllUsers(res)
//             try { console.debug('MyMessageChat: loaded allUsers (array) count', res.length, (res && res.slice && res.slice(0,3)) || res) } catch(e){}
//           }
//         }
//       } catch (e) { console.warn('load users error', e) }
//     })()
//     return () => { mounted = false }
//   }, [])

//   useEffect(() => {
//     const rawToken = localStorage.getItem('token')
//     const token = rawToken ? String(rawToken).replace(/^"|"$/g, '') : null
//     if (!token) { console.warn('No token for socket'); return }

//     const socket = io(SOCKET_URL, { auth: { token }, transports: ['websocket','polling'] })
//     socketRef.current = socket

//     socket.on('connect', () => console.debug('socket connected', socket.id))
//     socket.on('presence_snapshot', ({ online }) => {
//       try {
//         // online is array of { id, username }
//         console.debug('presence_snapshot', online)
//         const ids = new Set(); const names = new Set()
//         if (Array.isArray(online)) {
//           for (const it of online) {
//             try { if (it && it.id) ids.add(String(it.id)) } catch(e){}
//             try { if (it && it.username) names.add(String(it.username)) } catch(e){}
//           }
//         }
//         setPresence({ ids, names })
//       } catch(e){}
//     })

//     socket.on('presence_update', ({ userId, username, online }) => {
//       try {
//         console.debug('presence_update', { userId, username, online })
//         setPresence(prev => {
//           const ids = new Set(prev.ids || [])
//           const names = new Set(prev.names || [])
//           if (online) {
//             if (userId) ids.add(String(userId))
//             if (username) names.add(String(username))
//           } else {
//             if (userId) ids.delete(String(userId))
//             if (username) names.delete(String(username))
//           }
//           return { ids, names }
//         })
//       } catch(e){}
//     })

//     socket.on('joined_room', ({ room }) => {
//       try {
//         if (room) {
//           setCurrentRoomId(String(room))
//           currentRoomIdRef.current = String(room)
//           ;(async () => {
//             try {
//               const res = await fetchRoomMessages(room, chatTargetRef.current)
//               if (res && res.success && Array.isArray(res.messages)) {
//                 // merge buffered messages for this room/target
//                 const buf = getBufferedMessagesFor({ roomVal: room, idVal: extractId(chatTargetRef.current), usernameVal: chatTargetRef.current && chatTargetRef.current.username })
//                 const merged = (res.messages || []).concat(buf).filter((v, i, a) => a.findIndex(x => x.id === v.id) === i)
//                 setMessages(merged)
//                 cacheMessagesForRoom(room, merged)
//                 // clear those buffered
//                 if (buf && buf.length) setBufferedMessages(prev => { const c = { ...(prev||{}) }; delete c[`room:${String(room)}`]; if (chatTargetRef.current && chatTargetRef.current.username) delete c[`u:${String(chatTargetRef.current.username)}`]; delete c[`id:${String(extractId(chatTargetRef.current))}`]; return c })
//               }
//             } catch (e) { console.warn('joined_room fetch error', e) }
//           })()
//         }
//       } catch(e){}
//     })

//     socket.on('receive_message', (m) => {
//       try {
//         // normalize incoming message fields
//         const msg = Object.assign({}, m)
//         if (!msg.id) msg.id = `tmp-${Date.now()}-${Math.floor(Math.random()*10000)}`
//         if (!msg.room_id && msg.room) msg.room_id = msg.room
//         if (!msg.sender_id) msg.sender_id = msg.sender || msg.from_user || msg.user_id || null

//         const me = userRef.current || {}
//         const meId = extractId(me)
//         const currentTarget = chatTargetRef.current
//         const currentTargetId = extractId(currentTarget)
//         const currentRoom = currentRoomIdRef.current ? String(currentRoomIdRef.current) : null
//         const msgRoom = msg.room_id ? String(msg.room_id) : null
//         // Normalize sender id: prefer numeric canonical id, fallback to username string
//         let senderNumeric = null
//         try {
//           if (msg.sender_id && Number.isFinite(Number(msg.sender_id))) senderNumeric = Number(msg.sender_id)
//           else if (msg.sender && typeof msg.sender === 'object' && extractId(msg.sender)) senderNumeric = extractId(msg.sender)
//           else if (msg.sender_username) {
//             const known = (allUsers || []).find(x => String(x.username) === String(msg.sender_username))
//             if (known && known.id) senderNumeric = Number(known.id)
//           }
//         } catch(e){}
//         const senderId = senderNumeric ? String(senderNumeric) : (msg.sender_username ? String(msg.sender_username) : null)
//         if (senderNumeric) msg.sender_id = senderNumeric

//         const belongsToOpen = (msgRoom && currentRoom && String(msgRoom) === String(currentRoom)) || (currentTargetId && senderId && String(currentTargetId) === String(senderId))

//         if (belongsToOpen) {
//           setMessages(prev => {
//             const base = Array.isArray(prev) ? prev.slice() : []
//             if (base.find && base.find(x => String(x.id) === String(msg.id))) return base
//             base.push(msg)
//             // sort by created_at if available
//             try { base.sort((a,b)=> new Date(a.created_at || 0) - new Date(b.created_at || 0)) } catch(e){}
//             try { if (msgRoom) cacheMessagesForRoom(msgRoom, base) } catch(e){}
//             return base
//           })
//         } else {
//           // buffer for later and increment unread
//           const sid = senderId || (msg && msg.sender_username) || 'unknown'
//           const roomKeyVal = msgRoom
//           setBufferedMessages(prev => {
//             const copy = { ...(prev||{}) }
//             const idKey = `id:${String(sid)}`
//             copy[idKey] = copy[idKey] || []
//             if (!copy[idKey].find(x => String(x.id) === String(msg.id))) copy[idKey].push(msg)
//             if (roomKeyVal) {
//               const rk = `room:${String(roomKeyVal)}`
//               copy[rk] = copy[rk] || []
//               if (!copy[rk].find(x => String(x.id) === String(msg.id))) copy[rk].push(msg)
//             }
//             return copy
//           })
//           if (senderId && String(senderId) !== String(meId)) {
//             setUnreadCounts(prev => ({ ...(prev||{}), [String(senderId)]: (prev[String(senderId)]||0) + 1 }))
//             // move or insert recent chat for this sender to top with updated preview/time
//             try {
//               setRecentChats(prev => {
//                 const copy = Array.isArray(prev) ? prev.slice() : []
//                 const sid = String(senderId)
//                 const idx = copy.findIndex(x => String(x.other) === sid || (x.user && String(x.user.id) === sid))
//                   // Build sender object including fullname/avatar fields provided by the server
//                   const senderObj = (msg.sender && typeof msg.sender === 'object') ? msg.sender : (msg.sender_id ? { id: msg.sender_id, username: msg.sender_username || null, fullname: msg.sender_fullname || null, avatar: msg.sender_avatar || msg.sender_image || null } : { id: Number(senderId), username: msg.sender_username || null, fullname: msg.sender_fullname || null, avatar: msg.sender_avatar || msg.sender_image || null })
//                   const senderAvatar = senderObj.avatar || senderObj.image || msg.sender_avatar || msg.avatar || msg.image || null
//                   const known = (allUsers || []).find(x => {
//                     try {
//                       if (!x) return false
//                       if (x.id && String(x.id) === String(senderObj.id)) return true
//                       if (x.username && senderObj.username && String(x.username) === String(senderObj.username)) return true
//                       if (x.staff_id_number && senderObj.username && String(x.staff_id_number) === String(senderObj.username)) return true
//                       if (x.fullname && senderObj.fullname && String(x.fullname) === String(senderObj.fullname)) return true
//                       return false
//                     } catch(e){ return false }
//                   })
//                   const mergedUser = Object.assign({}, known || {}, senderObj, { avatar: senderAvatar, fullname: senderObj.fullname || (known && (known.fullname || known.name || known.staffname_kh1)) || null })
//                   const entry = { room: msg.room_id || null, other: Number(senderId), unread: ( (prev && prev.length && copy[idx] && copy[idx].unread) ? (copy[idx].unread + 1) : ( (Number((prev && prev.length && copy[idx]) ? copy[idx].unread : 0) || 0) + 1 ) ), lastMessagePreview: getPreviewFromMessage(msg), time: msg.created_at || new Date().toISOString(), user: mergedUser }
//                 if (idx >= 0) copy.splice(idx, 1)
//                 copy.unshift(entry)
//                 return copy
//               })
//             } catch(e){ console.warn('recentChats update error', e) }
//           }
//         }
//       } catch (e) { console.warn('receive_message handler error', e) }
//       // refresh rooms list so Recent reflects persisted messages/rooms
//       try { loadRooms().catch(()=>{}) } catch(e) {}
//     })

//     socket.on('typing', ({ room_id, sender_id }) => {
//       try {
//         const currentTargetId = extractId(chatTargetRef.current)
//         if ((currentTargetId && String(sender_id) === String(currentTargetId)) || (currentRoomIdRef.current && String(room_id) === String(currentRoomIdRef.current))) {
//           setTyping(true)
//           setTimeout(() => setTyping(false), 1400)
//         }
//       } catch(e){}
//     })

//     socket.on('stop_typing', () => setTyping(false))

//     socket.on('disconnect', () => console.debug('socket disconnected'))

//     return () => { try { socket.disconnect() } catch(e){} }
//   }, [SOCKET_URL])

//   async function fetchRoomMessages(roomCandidate, targetUser) {
//     try {
//       const str = roomCandidate === null || roomCandidate === undefined ? '' : String(roomCandidate)
//       if (/^\d+$/.test(str)) {
//         return await request(`messagechat/${str}`, 'get', {})
//       }
//       const tid = extractId(targetUser)
//       const q = tid ? `target_id=${String(tid)}` : `target_username=${encodeURIComponent((targetUser && targetUser.username) || '')}`
//       const rv = await request(`messagechat/resolve?${q}`, 'get', {})
//       if (rv && rv.success && rv.room) return await request(`messagechat/${String(rv.room)}`, 'get', {})
//       return { success: false, messages: [] }
//     } catch(e) { return { success: false, messages: [] } }
//   }

//   function getBufferedMessagesFor({ idVal, usernameVal, roomVal }) {
//     const parts = []
//     try {
//       if (idVal) {
//         const k = `id:${String(idVal)}`
//         parts.push(...(bufferedMessages && bufferedMessages[k] ? bufferedMessages[k] : []))
//       }
//       if (usernameVal) {
//         const k2 = `u:${String(usernameVal)}`
//         parts.push(...(bufferedMessages && bufferedMessages[k2] ? bufferedMessages[k2] : []))
//       }
//       if (roomVal) {
//         const k3 = `room:${String(roomVal)}`
//         parts.push(...(bufferedMessages && bufferedMessages[k3] ? bufferedMessages[k3] : []))
//       }
//     } catch(e){}
//     return parts
//   }

//   async function startPrivateChat(u) {
//     setChatTarget(u)
//     chatTargetRef.current = u
//     setUnreadCounts(prev => { const c = { ...(prev||{}) }; delete c[String(extractId(u))]; return c })
//     try {
//       // move this chat to top and clear its unread in recentChats
//       setRecentChats(prev => {
//         const copy = Array.isArray(prev) ? prev.slice() : []
//         const uid = String(extractId(u))
//         const idx = copy.findIndex(x => String(x.other) === uid || (x.user && String(x.user.id) === uid))
//         const entry = idx >= 0 ? copy[idx] : { room: null, other: Number(uid), unread: 0, lastMessagePreview: null, time: null, user: (u || {}) }
//         entry.unread = 0
//         if (idx >= 0) copy.splice(idx,1)
//         copy.unshift(entry)
//         return copy
//       })
//     } catch(e){ console.warn('startPrivateChat recentChats update error', e) }

//     // resolve canonical room via server, join and load messages
//     try {
//       const targetId = extractId(u)
//       const q = targetId ? `target_id=${String(targetId)}` : `target_username=${encodeURIComponent((u && u.username) || '')}`
//       console.debug('startPrivateChat: resolving room for target', { target: u, targetId, q })
//       const resv = await request(`messagechat/resolve?${q}`, 'get', {})
//       console.debug('startPrivateChat: resolve response', resv)
//       let room = null
//       if (resv && resv.success && resv.room) room = String(resv.room)

//       try {
//         setRecentChats(prev => {
//           const copy = Array.isArray(prev) ? prev.slice() : []
//           const uid = String(extractId(u))
//           const idx = copy.findIndex(x => String(x.other) === uid || (x.user && String(x.user.id) === uid))
//           const baseUser = u || {}
//           const known = (allUsers || []).find(x => String(x.id) === uid || String(x.username) === String(baseUser.username || ''))
//           const avatar = baseUser.avatar || baseUser.image || (known && known.avatar) || null
//           const fullname = baseUser.fullname || (known && (known.fullname || known.name || known.staffname_kh1)) || null
//           const entry = idx >= 0 ? copy[idx] : { room: room || null, other: Number(uid), unread: 0, lastMessagePreview: null, time: null, user: Object.assign({}, known || {}, baseUser, { avatar, fullname }) }
//           entry.unread = 0
//           if (idx >= 0) copy.splice(idx,1)
//           copy.unshift(entry)
//           return copy
//         })
//       } catch(e){ console.warn('startPrivateChat recentChats update error', e) }

//       if (socketRef.current && room) socketRef.current.emit('join_room', String(room))
//       const resm = await fetchRoomMessages(room, u)
//       console.debug('startPrivateChat: fetchRoomMessages result', resm)
//       if (resm && resm.success && Array.isArray(resm.messages)) {
//         const buf = getBufferedMessagesFor({ idVal: extractId(u), usernameVal: u && u.username ? u.username : null, roomVal: room })
//         console.debug('startPrivateChat: buffered messages count', (buf && buf.length) || 0)
//         const merged = (resm.messages || []).concat(buf).filter((v, i, a) => a.findIndex(x => x.id === v.id) === i)
//         try { merged.sort((a,b)=> new Date(a.created_at || 0) - new Date(b.created_at || 0)) } catch(e){}
//         setMessages(merged)
//         cacheMessagesForRoom(room, merged)
//         if (buf && buf.length) setBufferedMessages(prev => { const c = { ...(prev||{}) }; delete c[`id:${String(extractId(u))}`]; if (u && u.username) delete c[`u:${String(u.username)}`]; delete c[`room:${String(room)}`]; return c })
//       } else {
//         console.debug('startPrivateChat: no server messages, keeping cached')
//       }
//     } catch(e){ console.warn('startPrivateChat error', e) }
//   }

//   async function sendSocketMessage(files, overrideText) {
//     if (!chatTarget) return
//     if (isConverting) return
//     const text = (typeof overrideText === 'string' ? overrideText : (messageText && messageText.trim()))
//     if (!text && (!files || !files.length)) return
//     try {
//       // conversion happens at attach time via prepareFiles; no-op here
//       const myUser = userRef.current || getCurrentUser()
//       const myId = extractId(myUser)
//       const targetId = extractId(chatTarget)
//       // resolve room
//       let roomToUse = null
//       try {
//         const q = targetId ? `target_id=${String(targetId)}` : `target_username=${encodeURIComponent(String(chatTarget.username||''))}`
//         const rv = await request(`messagechat/resolve?${q}`, 'get', {})
//         if (rv && rv.success && rv.room) roomToUse = String(rv.room)
//       } catch(e){}
//       if (!roomToUse) {
//         const computed = computeRoomId(myId, targetId)
//         if (computed === null) return
//         roomToUse = String(computed)
//       }
//       const payload = { room_id: String(roomToUse), message: text || '', sender_id: myId }
//       // if files provided, read as base64 and attach
//       if (files && Array.isArray(files) && files.length) {
//         // First, for any HEIC files, attempt server-side conversion via /api/messagechat/convert
//         const convertRemote = async (file) => {
//           try {
//             const rawToken = localStorage.getItem('token')
//             const token = rawToken ? String(rawToken).replace(/^\"|\"$/g, '') : null
//             const fd = new FormData()
//             fd.append('file', file)
//             const url = (base_url || '').replace(/\/$/, '') + '/messagechat/convert'
//             const resp = await fetch(url, { method: 'POST', headers: token ? { 'Authorization': 'Bearer ' + token } : {}, body: fd })
//             let j = null
//             try { j = await resp.json() } catch(e) { const txt = await resp.text().catch(()=>null); console.warn('convertRemote: non-json response', resp.status, txt); }
//             if (!resp.ok) {
//               console.warn('convertRemote: server responded', resp.status, j)
//             }
//             if (j && j.success && j.file) return j.file
//           } catch (e) { console.warn('remote convert failed', e) }
//           return null
//         }

//         const compressImage = (file, maxWidth = 1280, quality = 0.75) => new Promise((resolve) => {
//           try {
//             const img = new Image()
//             img.onload = () => {
//               try {
//                 const ratio = img.width / img.height
//                 let w = img.width
//                 let h = img.height
//                 if (w > maxWidth) {
//                   w = maxWidth
//                   h = Math.round(w / ratio)
//                 }
//                 const canvas = document.createElement('canvas')
//                 canvas.width = w
//                 canvas.height = h
//                 const ctx = canvas.getContext('2d')
//                 ctx.drawImage(img, 0, 0, w, h)
//                 const dataUrl = canvas.toDataURL('image/jpeg', quality)
//                 const idx = dataUrl.indexOf(',')
//                 const b64 = idx >= 0 ? dataUrl.slice(idx+1) : dataUrl
//                 resolve({ data: b64, mimetype: 'image/jpeg', previewUrl: dataUrl })
//               } catch (e) { resolve(null) }
//             }
//             img.onerror = () => resolve(null)
//             img.src = URL.createObjectURL(file)
//           } catch (e) { resolve(null) }
//         })

//         const readFileAsBase64 = async (file) => {
//           try {
//             // Detect HEIC/HEIF and skip client convert (many browsers can't decode HEIC)
//             const name = (file && file.name) ? String(file.name).toLowerCase() : ''
//             const isHeic = (file && file.type && String(file.type).toLowerCase().includes('heic')) || name.endsWith('.heic') || name.endsWith('.heif')
//             let preview = null
//             try { preview = URL.createObjectURL(file) } catch(e) { preview = null }
//             // if HEIC, try server-side conversion first
       
// // inside readFileAsBase64(file) where you detect isHeic:
// if (isHeic) {
//   try {
//     // try client conversion
//     const convertedBlob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.8 })
//     const dataUrl = await new Promise((resolve, reject) => {
//       const fr = new FileReader()
//       fr.onload = () => resolve(fr.result)
//       fr.onerror = reject
//       fr.readAsDataURL(convertedBlob)
//     })
//     const idx = String(dataUrl).indexOf(',')
//     const b64 = idx >= 0 ? String(dataUrl).slice(idx+1) : String(dataUrl)
//     return { originalname: file.name.replace(/\.(heic|heif)$/i, '.jpg'), mimetype: 'image/jpeg', data: b64, previewUrl: dataUrl }
//   } catch (e) {
//     // client convert failed — fall back to server convert
//     console.warn('heic2any convert failed, falling back to server convert', e)
//     const remote = await convertRemote(file)
//     if (remote && remote.base64) {
//       const mim = remote.mime || 'image/jpeg'
//       const b64 = remote.base64
//       const dataUrl = remote.url ? (remote.url.startsWith('http') ? remote.url : ((base_url||'').replace(/\/$/,'') + remote.url)) : (mim && mim.startsWith('image/') ? `data:${mim};base64,${b64}` : null)
//       return { originalname: remote.originalName || file.name, mimetype: mim, data: b64, previewUrl: dataUrl }
//     }
//   }
// }
//             // if image and not HEIC, attempt client-side compression/resize
//             if (file && file.type && String(file.type).startsWith('image/') && !isHeic) {
//               const compressed = await compressImage(file)
//               if (compressed && compressed.data) {
//                 return { originalname: file.name, mimetype: compressed.mimetype || file.type || '', data: compressed.data, previewUrl: compressed.previewUrl || preview }
//               }
//             }
//             // fallback: read original as base64
//             return await new Promise((resolve, reject) => {
//               try {
//                 const reader = new FileReader()
//                 reader.onload = () => {
//                   const result = reader.result || ''
//                   const idx = String(result).indexOf(',')
//                   const b64 = idx >= 0 ? String(result).slice(idx+1) : String(result)
//                   resolve({ originalname: file.name, mimetype: file.type || '', data: b64, previewUrl: preview })
//                 }
//                 reader.onerror = (e) => reject(e)
//                 reader.readAsDataURL(file)
//               } catch (e) { reject(e) }
//             })
//           } catch (e) { return { originalname: file.name, mimetype: file.type || '', data: '', previewUrl: null } }
//         }
//         const attaches = []
//         for (const f of files) {
//           try {
//             const out = await readFileAsBase64(f)
//             attaches.push(out)
//           } catch(e) { console.warn('file read failed', e) }
//         }
//         if (attaches.length) payload.attachments = attaches
//       }

//       socketRef.current && socketRef.current.emit('send_message', payload)
//       // refresh rooms from server so Recent list reflects saved message/room
//       try { await loadRooms() } catch(e) { console.warn('loadRooms after send failed', e) }
//       // append locally: mimic server-saved message so images show immediately
//       let localSaved = null
//       try {
//         const tmpId = `tmp-${Date.now()}-${Math.floor(Math.random()*10000)}`
//         const now = new Date().toISOString()
//         localSaved = { id: tmpId, room_id: String(roomToUse), sender_id: myId, created_at: now }
//         if (payload && Array.isArray(payload.attachments) && payload.attachments.length) {
//           // create preview URLs for immediate display
//           const localFiles = []
//           for (let i = 0; i < payload.attachments.length; i++) {
//             const a = payload.attachments[i]
//             const originalName = a.originalname || a.filename || (`file_${i}`)
//             const mime = a.mimetype || a.mime || a.type || ''
//             // if original File object available (when ChatWindow passed files), a.previewUrl may exist; otherwise fall back to data: URL
//             const url = a.previewUrl || (a.data ? `data:${mime};base64,${a.data}` : null)
//             localFiles.push({ originalName, filename: a.filename || originalName, mime, url })
//           }
//           localSaved.type = 'image'
//           localSaved.message = JSON.stringify({ files: localFiles, caption: payload.message || '' })
//           localSaved.sender_username = myUser && myUser.username ? myUser.username : null
//           localSaved.sender_fullname = myUser && (myUser.fullname || myUser.staffname_kh1 || myUser.name) ? (myUser.fullname || myUser.staffname_kh1 || myUser.name) : null
//           localSaved.sender_avatar = myUser && (myUser.avatar || myUser.image) ? (myUser.avatar || myUser.image) : null
//         } else {
//           localSaved.type = 'text'
//           localSaved.message = payload.message || ''
//           localSaved.sender_username = myUser && myUser.username ? myUser.username : null
//           localSaved.sender_fullname = myUser && (myUser.fullname || myUser.staffname_kh1 || myUser.name) ? (myUser.fullname || myUser.staffname_kh1 || myUser.name) : null
//           localSaved.sender_avatar = myUser && (myUser.avatar || myUser.image) ? (myUser.avatar || myUser.image) : null
//         }
//         setMessages(prev => {
//           const p = prev && Array.isArray(prev) ? prev : []
//           const next = [...p, localSaved]
//           try { cacheMessagesForRoom(String(roomToUse), next) } catch(e){}
//           return next
//         })
//       } catch(e) {
//         try { console.warn('local append error', e) } catch(_){}
//       }
//       // move this chat to top in recentChats and clear unread
//       try {
//         setRecentChats(prev => {
//           const copy = Array.isArray(prev) ? prev.slice() : []
//           const uid = String(targetId)
//           const idx = copy.findIndex(x => String(x.other) === uid || (x.user && String(x.user.id) === uid))
//           const known = (allUsers || []).find(x => String(x.id) === uid || String(x.username) === String((chatTarget && chatTarget.username) || ''))
//           const baseUser = chatTarget || {}
//           const avatar = baseUser.avatar || baseUser.image || (known && known.avatar) || null
//           const fullname = baseUser.fullname || (known && (known.fullname || known.name || known.staffname_kh1)) || null
//           const entry = idx >= 0 ? copy[idx] : { room: String(roomToUse), other: Number(uid), unread: 0, lastMessagePreview: messageText || '', time: new Date().toISOString(), user: Object.assign({}, known || {}, baseUser, { avatar, fullname }) }
//           entry.lastMessagePreview = getPreviewFromMessage(localSaved) || (messageText || '')
//           entry.time = new Date().toISOString()
//           entry.unread = 0
//           if (idx >= 0) copy.splice(idx,1)
//           copy.unshift(entry)
//           return copy
//         })
//       } catch(e) { console.warn('sendSocketMessage recentChats update error', e) }
//      // console.debug('sendSocketMessage payload', payload)
//      console.debug('sendSocketMessage: emitted message, payload', payload, 'localSaved', localSaved)
     
//       setMessageText('')

//     } catch(e) { console.error('sendSocketMessage error', e) }
//     finally {
//       try { if (isConverting) setIsConverting(false) } catch(_){}
//     }
//   }

//   function handleTypingInput(val) {
//     try {
//       const text = val || ''
//       const socket = socketRef.current
//       const room = currentRoomIdRef.current ? String(currentRoomIdRef.current) : null
//       const me = userRef.current || {}
//       const meId = extractId(me)
//       if (!socket) return
//       if (text && String(text).trim().length > 0) {
//         socket.emit('typing', { room_id: room, sender_id: meId })
//         if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current)
//         typingTimeoutRef.current = setTimeout(() => {
//           try { socket.emit('stop_typing', { room_id: room, sender_id: meId }) } catch(e){}
//         }, 1400)
//       } else {
//         try { socket.emit('stop_typing', { room_id: room, sender_id: meId }) } catch(e){}
//         if (typingTimeoutRef.current) { clearTimeout(typingTimeoutRef.current); typingTimeoutRef.current = null }
//       }
//     } catch(e) { console.warn('handleTypingInput error', e) }
//   }

//   // simple UI
//   function handleLogout() { try { localStorage.removeItem('token') } catch(e){} window.location.href = '/login' }

//   useEffect(() => { if (!messagesEndRef.current) return; messagesEndRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' }) }, [messages])

//   useEffect(() => {
//     const check = () => {
//       try { setIsMobile(typeof window !== 'undefined' && window.innerWidth <= 720) } catch(e) { setIsMobile(false) }
//     }
//     check()
//     window.addEventListener('resize', check)
//     return () => window.removeEventListener('resize', check)
//   }, [])

//   // Helper to call server-side convert endpoint (fallback)
//   const convertRemote = async (file) => {
//     try {
//       const rawToken = localStorage.getItem('token')
//       const token = rawToken ? String(rawToken).replace(/^"|"$/g, '') : null
//       const fd = new FormData()
//       fd.append('file', file)
//       const url = (base_url || '').replace(/\/$/, '') + '/messagechat/convert'
//       const resp = await fetch(url, { method: 'POST', headers: token ? { 'Authorization': 'Bearer ' + token } : {}, body: fd })
//       let j = null
//       try { j = await resp.json() } catch(e) { const txt = await resp.text().catch(()=>null); console.warn('convertRemote: non-json response', resp.status, txt); }
//       if (!resp.ok) {
//         console.warn('convertRemote: server responded', resp.status, j)
//       }
//       if (j && j.success && j.file) return j.file
//     } catch (e) { console.warn('remote convert failed', e) }
//     return null
//   }

//   // prepareFiles: convert HEIC client-side (heic2any) or fallback to server; returns array of { file, preview }
//   const prepareFiles = async (files) => {
//     if (!files || !files.length) return []
//     setIsConverting(true)
//     const out = []
//     try {
//       for (const f of files) {
//         try {
//           const name = (f && f.name) ? String(f.name).toLowerCase() : ''
//           const isHeic = (f && f.type && String(f.type).toLowerCase().includes('heic')) || name.endsWith('.heic') || name.endsWith('.heif')
//           if (isHeic) {
//             try {
//               const conv = await heic2any({ blob: f, toType: 'image/jpeg', quality: 0.8 })
//               const blob = (conv && conv.length && conv[0]) ? conv[0] : conv
//               const newName = (f.name || '').replace(/\.(heic|heif)$/i, '.jpg')
//               const newFile = new File([blob], newName, { type: 'image/jpeg' })
//               const preview = URL.createObjectURL(newFile)
//               out.push({ file: newFile, preview })
//               continue
//             } catch (e) {
//               console.warn('prepareFiles: heic2any failed, trying server convert', e)
//               const remote = await convertRemote(f)
//               if (remote && remote.base64) {
//                 const mim = remote.mime || 'image/jpeg'
//                 const b64 = remote.base64
//                 const dataUrl = remote.url ? (remote.url.startsWith('http') ? remote.url : ((base_url||'').replace(/\/$/,'') + remote.url)) : (mim && mim.startsWith('image/') ? `data:${mim};base64,${b64}` : null)
//                 // create a blob from base64
//                 try {
//                   const res = await fetch(dataUrl)
//                   const blob = await res.blob()
//                   const newName = (f.name || '').replace(/\.(heic|heif)$/i, '.jpg')
//                   const newFile = new File([blob], newName, { type: mim })
//                   const preview = dataUrl
//                   out.push({ file: newFile, preview })
//                   continue
//                 } catch (er) {
//                   console.warn('prepareFiles: failed to create blob from remote base64', er)
//                 }
//               }
//             }
//           }
//           // not HEIC or conversions failed: keep original file and preview
//           const preview = f.type && f.type.startsWith('image/') ? URL.createObjectURL(f) : null
//           out.push({ file: f, preview })
//         } catch (e) { console.warn('prepareFiles: file processing failed', e); const preview = f && f.type && f.type.startsWith('image/') ? URL.createObjectURL(f) : null; out.push({ file: f, preview }) }
//       }
//     } finally {
//       setIsConverting(false)
//     }
//     return out
//   }

//   return (
//     <div style={{ height: isMobile ? '75vh' : '100%', display: 'flex', flexDirection: 'column' }}>
//       <div className="mobile-search" style={{ padding: '8px' }}>
//         <input  className="search-input" placeholder="ស្វែងរកឈ្មោះបុគ្គលិក...." allowClear value={mobileSearchQuery} onChange={(e) => setMobileSearchQuery(e.target.value)} />
//       </div>
//       <div className="message-chat-root" style={{ display: 'flex', height: '100%' }}>
//         <div style={{ width: (isMobile ? 70 : 320), borderRight: '1px solid #eee' }}>
//           {isMobile ? (
//             <SidebarChat user={user} allUsers={allUsers} chatTarget={chatTarget} unreadCounts={unreadCounts} recentChats={recentChats} onChat={startPrivateChat} onLogout={handleLogout} presence={presence} search={mobileSearchQuery} onSearchChange={setMobileSearchQuery} />
//           ) : (
//             <SidebarChat user={user} allUsers={allUsers} chatTarget={chatTarget} unreadCounts={unreadCounts} recentChats={recentChats} onChat={startPrivateChat} onLogout={handleLogout} presence={presence} />
//           )}
//         </div>
//         <div style={{ flex: 1,width: (isMobile ? 70 : '100%'), height: (isMobile ? '75vh' : '100%') }}>
//           <ChatWindow chatTarget={chatTarget} messages={messages} user={user} messageText={messageText} setMessageText={(v) => { setMessageText(v); handleTypingInput(v) }} onSend={sendSocketMessage} messagesEndRef={messagesEndRef} typing={typing} presence={presence} isConverting={isConverting} onPrepareFiles={prepareFiles} />
//         </div>
//       </div>
//     </div>
//   )
// }



import React, { useEffect, useRef, useState } from 'react'
import './styles.css'
import SidebarChat from './components/Sidebar'
import ChatWindow from './components/ChatWindow'
import { request } from '../../share/request'
import { getCurrentUser } from '../../share/getProfile'
import { base_url, domain, linkPath } from '../../share/helper'
import { io } from 'socket.io-client'
import heic2any from 'heic2any'

export default function MyMessageChat() {
  const [user, setUser] = useState(getCurrentUser())
  const [allUsers, setAllUsers] = useState([])
  const [chatTarget, setChatTarget] = useState(null)
  const [messages, setMessages] = useState([])
  const [currentRoomId, setCurrentRoomId] = useState(null)
  const [bufferedMessages, setBufferedMessages] = useState({})
  const [messageText, setMessageText] = useState('')
  const [unreadCounts, setUnreadCounts] = useState({})
  const [recentChats, setRecentChats] = useState([])
  const [typing, setTyping] = useState(false)
  const [isConverting, setIsConverting] = useState(false)
  const [mobileSearchQuery, setMobileSearchQuery] = useState('')
  const [isMobile, setIsMobile] = useState(false)
  
  // 🔥 Group state
  const [groups, setGroups] = useState([])
  const [groupMessages, setGroupMessages] = useState({})
  const [groupUnreadCounts, setGroupUnreadCounts] = useState({})
  
  // presence: store separate sets for ids and usernames
  const [presence, setPresence] = useState({ ids: new Set(), names: new Set() })

  const socketRef = useRef(null)
  const messagesEndRef = useRef(null)
  const typingTimeoutRef = useRef(null)
  const userRef = useRef(user)
  const chatTargetRef = useRef(chatTarget)
  const currentRoomIdRef = useRef(currentRoomId)

  function extractId(u) {
    if (!u) return null
    const maybe = u.id || u.user_id || u.userId || u.staff_id || u.staffid || u.staffId
    const n = Number(maybe)
    if (Number.isFinite(n) && n > 0) return n
    if (u.username) {
      const nx = Number(u.username)
      if (Number.isFinite(nx) && nx > 0) return nx
    }
    return null
  }

  function computeRoomId(a, b) {
    const ai = Number(a)
    const bi = Number(b)
    if (!Number.isFinite(ai) || !Number.isFinite(bi)) return null
    const low = Math.min(ai, bi)
    const high = Math.max(ai, bi)
    return (low * 1000000) + high
  }
  
  function getPreviewFromMessage(msg) {
    try {
      if (!msg) return ''
      let body = null
      if (typeof msg.message === 'string') {
        try { body = JSON.parse(msg.message) } catch(e) { body = msg.message }
      } else if (msg.message && typeof msg.message === 'object') {
        body = msg.message
      } else if (typeof msg === 'string') {
        try { body = JSON.parse(msg) } catch(e) { body = msg }
      } else if (msg && typeof msg === 'object' && (msg.files || msg.caption)) {
        body = msg
      }

      if (body && typeof body === 'object') {
        const files = Array.isArray(body.files) ? body.files : (Array.isArray(body.attachments) ? body.attachments : null)
        const caption = body.caption || body.text || body.caption_text || ''
        if (caption && String(caption).trim()) return String(caption).trim()
        if (files && files.length) {
          const first = files[0]
          try {
            const fname = first.originalName || first.filename || first.name || (first.url ? (first.url.split('/').pop()) : null)
            if (files.length === 1) return fname || 'Sent a file'
            return `Sent ${files.length} files${fname ? ` — ${fname}` : ''}`
          } catch(e) { return `Sent ${files.length} files` }
        }
      }

      return (msg && (msg.message || msg.text || msg.body)) ? String(msg.message || msg.text || msg.body) : ''
    } catch(e) { return '' }
  }

  function cacheMessagesForRoom(roomId, msgs) {
    try { if (!roomId) return; localStorage.setItem(`chat_cache_room:${String(roomId)}`, JSON.stringify(msgs || [])) } catch(e){}
  }
  
  function loadCachedMessages(roomId) {
    try { if (!roomId) return []; const raw = localStorage.getItem(`chat_cache_room:${String(roomId)}`); if (!raw) return []; const parsed = JSON.parse(raw); return Array.isArray(parsed) ? parsed : [] } catch(e){ return [] }
  }

  // SOCKET URL heuristics
  let SOCKET_URL = (base_url || '').replace(/\/api\/?$/,'') || window.location.origin
  try { const host = domain ? new URL(domain).hostname : null; if (host === 'localhost' || host === '127.0.0.1') SOCKET_URL = `${window.location.protocol}//${host}:8084` } catch(e){}

  useEffect(() => { userRef.current = user }, [user])
  useEffect(() => { chatTargetRef.current = chatTarget }, [chatTarget])
  useEffect(() => { currentRoomIdRef.current = currentRoomId }, [currentRoomId])

  // 🔥 Fetch groups from API
  const fetchGroups = async () => {
    try {
      console.log('📥 Fetching groups...')
      const res = await request('groupschat', 'get', {})
      console.log('📥 Groups response:', res)
      if (res && res.success && Array.isArray(res.groups)) {
        setGroups(res.groups)
        
        // Build group unread counts
        const unreadMap = {}
        for (const group of res.groups) {
          try {
            const unreadRes = await request(`groupschat/${group.id}/unread`, 'get', {})
            if (unreadRes && unreadRes.success) {
              unreadMap[String(group.id)] = unreadRes.unread_count || 0
            }
          } catch (e) {
            console.warn(`Failed to get unread for group ${group.id}:`, e)
          }
        }
        setGroupUnreadCounts(unreadMap)
      }
    } catch (error) {
      console.error('Error fetching groups:', error)
    }
  }

  // 🔥 Fetch group messages
  const fetchGroupMessages = async (roomId) => {
    try {
      console.log(`📥 Fetching group messages for room ${roomId}`)
      const res = await request(`groupmessagechat/group/${roomId}`, 'get', {})
      console.log(`📥 Group messages response:`, res)
      if (res && res.success && Array.isArray(res.messages)) {
        setGroupMessages(prev => ({
          ...prev,
          [roomId]: res.messages
        }))
        return res.messages
      }
      return []
    } catch (error) {
      console.error('Error fetching group messages:', error)
      return []
    }
  }

  // 🔥 Send group message
  const sendGroupMessage = async (roomId, message, files = null) => {
    try {
      const formData = new FormData()
      if (message) formData.append('message', message)
      if (files && files.length) {
        for (const file of files) {
          formData.append('files', file)
        }
      }
      
      const res = await request(`groupmessagechat/group/${roomId}`, 'post', formData)
      if (res && res.success) {
        return res.message
      }
      console.log("data message: ",res.message)
      return null
    } catch (error) {
      console.error('Error sending group message:', error)
      return null
    }
  }

  // 🔥 Mark group messages as read
  const markGroupMessagesRead = async (roomId) => {
    try {
      await request(`groupmessagechat/${roomId}/read`, 'post', {})
      return true
    } catch (error) {
      console.error('Error marking group messages read:', error)
      return false
    }
  }

  // fetch rooms/unread counts to populate sidebar badges
  const loadRooms = async () => {
    try {
      const res = await request('messagechat/rooms', 'get', {})
      if (res && res.success && Array.isArray(res.rooms)) {
        const map = {}
        res.rooms.forEach(r => {
          if (r && r.other) map[String(r.other)] = Number(r.unread || 0)
        })
        setUnreadCounts(map)
        try {
          const rc = res.rooms.map(r => {
            const ru = r.user || {}
            const avatar = ru.avatar || ru.image || ru.photo || null
            return ({ room: r.room, other: r.other, unread: r.unread || 0, lastMessagePreview: getPreviewFromMessage({ message: r.lastMessagePreview }), time: r.time || null, user: Object.assign({}, ru, { avatar }) })
          })
          setRecentChats(rc)
        } catch(e) { console.warn('populate recentChats error', e) }
      }
    } catch (e) { console.warn('load rooms/unread error', e) }
  }

  // load user list for sidebar
  useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const me = userRef.current || getCurrentUser()
        const params = new URLSearchParams({})
        if (me && me.org_code) params.append('org_code', String(me.org_code))
        const res = await request(`lettersjoiner?${params.toString()}`, 'get', {})
        if (mounted && res) {
          if (res.api_server_list_joiner && Array.isArray(res.api_server_list_joiner)) {
            const mapped = res.api_server_list_joiner.map(item => {
              const rawImage = item.image || null
              let image_url = null
              try {
                if (rawImage && (String(rawImage).startsWith('http://') || String(rawImage).startsWith('https://'))) image_url = rawImage
                else if (rawImage && String(rawImage).startsWith('/')) image_url = linkPath + String(rawImage).replace(/^\//, '')
                else if (rawImage) image_url = linkPath.endsWith('/') ? linkPath + rawImage : linkPath + '/' + rawImage
              } catch(e) { image_url = rawImage }
              return {
                id: item.id,
                username: item.staff_id_number || item.username || '',
                fullname: item.staffname_kh1 || item.staffname_en || item.fullname || '',
                staffname_eng: item.staffname_en || '',
                position: item.position_kh || item.position_en || '',
                department_name: item.department_name || '',
                image: rawImage || null,
                avatar: image_url
              }
            })
            setAllUsers(mapped)
          } else if (Array.isArray(res)) {
            setAllUsers(res)
          }
        }
      } catch (e) { console.warn('load users error', e) }
    })()
    return () => { mounted = false }
  }, [])

  // 🔥 Handle chat selection (supports both private and group)
  const handleChatSelect = async (target) => {
    console.log('🔍 handleChatSelect called with:', target)
    
    if (target?.is_group) {
      // 🔥 GROUP CHAT
      console.log('👥 Starting group chat:', target)
      const groupTarget = {
        id: target.id,
        fullname: target.fullname || target.name,
        username: target.username || target.name,
        avatar: target.avatar,
        is_group: true,
        room_id: target.room_id,
        member_count: target.member_count
      }
      setChatTarget(groupTarget)
      chatTargetRef.current = groupTarget
      
      // Fetch group messages
      if (target.room_id) {
        const messages = await fetchGroupMessages(target.room_id)
        setMessages(messages)
        // Mark as read
        await markGroupMessagesRead(target.room_id)
        // Update group unread counts
        setGroupUnreadCounts(prev => ({
          ...prev,
          [String(target.id)]: 0
        }))
        // Join room via socket
        if (socketRef.current && target.room_id) {
          socketRef.current.emit('join_room', String(target.room_id))
        }
      }
    } else {
      // 🔥 PRIVATE CHAT
      await startPrivateChat(target)
    }
  }

  // Private chat logic
  const startPrivateChat = async (u) => {
    setChatTarget(u)
    chatTargetRef.current = u
    setUnreadCounts(prev => { const c = { ...(prev||{}) }; delete c[String(extractId(u))]; return c })
    try {
      setRecentChats(prev => {
        const copy = Array.isArray(prev) ? prev.slice() : []
        const uid = String(extractId(u))
        const idx = copy.findIndex(x => String(x.other) === uid || (x.user && String(x.user.id) === uid))
        const entry = idx >= 0 ? copy[idx] : { room: null, other: Number(uid), unread: 0, lastMessagePreview: null, time: null, user: (u || {}) }
        entry.unread = 0
        if (idx >= 0) copy.splice(idx,1)
        copy.unshift(entry)
        return copy
      })
    } catch(e){ console.warn('startPrivateChat recentChats update error', e) }

    try {
      const targetId = extractId(u)
      const q = targetId ? `target_id=${String(targetId)}` : `target_username=${encodeURIComponent((u && u.username) || '')}`
      const resv = await request(`messagechat/resolve?${q}`, 'get', {})
      let room = null
      if (resv && resv.success && resv.room) room = String(resv.room)

      try {
        setRecentChats(prev => {
          const copy = Array.isArray(prev) ? prev.slice() : []
          const uid = String(extractId(u))
          const idx = copy.findIndex(x => String(x.other) === uid || (x.user && String(x.user.id) === uid))
          const baseUser = u || {}
          const known = (allUsers || []).find(x => String(x.id) === uid || String(x.username) === String(baseUser.username || ''))
          const avatar = baseUser.avatar || baseUser.image || (known && known.avatar) || null
          const fullname = baseUser.fullname || (known && (known.fullname || known.name || known.staffname_kh1)) || null
          const entry = idx >= 0 ? copy[idx] : { room: room || null, other: Number(uid), unread: 0, lastMessagePreview: null, time: null, user: Object.assign({}, known || {}, baseUser, { avatar, fullname }) }
          entry.unread = 0
          if (idx >= 0) copy.splice(idx,1)
          copy.unshift(entry)
          return copy
        })
      } catch(e){ console.warn('startPrivateChat recentChats update error', e) }

      if (socketRef.current && room) socketRef.current.emit('join_room', String(room))
      const resm = await fetchRoomMessages(room, u)
      if (resm && resm.success && Array.isArray(resm.messages)) {
        const buf = getBufferedMessagesFor({ idVal: extractId(u), usernameVal: u && u.username ? u.username : null, roomVal: room })
        const merged = (resm.messages || []).concat(buf).filter((v, i, a) => a.findIndex(x => x.id === v.id) === i)
        try { merged.sort((a,b)=> new Date(a.created_at || 0) - new Date(b.created_at || 0)) } catch(e){}
        setMessages(merged)
        cacheMessagesForRoom(room, merged)
        if (buf && buf.length) setBufferedMessages(prev => { const c = { ...(prev||{}) }; delete c[`id:${String(extractId(u))}`]; if (u && u.username) delete c[`u:${String(u.username)}`]; delete c[`room:${String(room)}`]; return c })
      }
    } catch(e){ console.warn('startPrivateChat error', e) }
  }

  async function fetchRoomMessages(roomCandidate, targetUser) {
    try {
      const str = roomCandidate === null || roomCandidate === undefined ? '' : String(roomCandidate)
      if (/^\d+$/.test(str)) {
        return await request(`messagechat/${str}`, 'get', {})
      }
      const tid = extractId(targetUser)
      const q = tid ? `target_id=${String(tid)}` : `target_username=${encodeURIComponent((targetUser && targetUser.username) || '')}`
      const rv = await request(`messagechat/resolve?${q}`, 'get', {})
      if (rv && rv.success && rv.room) return await request(`messagechat/${String(rv.room)}`, 'get', {})
      return { success: false, messages: [] }
    } catch(e) { return { success: false, messages: [] } }
  }

  function getBufferedMessagesFor({ idVal, usernameVal, roomVal }) {
    const parts = []
    try {
      if (idVal) {
        const k = `id:${String(idVal)}`
        parts.push(...(bufferedMessages && bufferedMessages[k] ? bufferedMessages[k] : []))
      }
      if (usernameVal) {
        const k2 = `u:${String(usernameVal)}`
        parts.push(...(bufferedMessages && bufferedMessages[k2] ? bufferedMessages[k2] : []))
      }
      if (roomVal) {
        const k3 = `room:${String(roomVal)}`
        parts.push(...(bufferedMessages && bufferedMessages[k3] ? bufferedMessages[k3] : []))
      }
    } catch(e){}
    return parts
  }

  // Socket setup
  useEffect(() => {
    const rawToken = localStorage.getItem('token')
    const token = rawToken ? String(rawToken).replace(/^"|"$/g, '') : null
    if (!token) { console.warn('No token for socket'); return }

    const socket = io(SOCKET_URL, { auth: { token }, transports: ['websocket','polling'] })
    socketRef.current = socket

    socket.on('connect', () => console.debug('socket connected', socket.id))
    socket.on('presence_snapshot', ({ online }) => {
      try {
        const ids = new Set(); const names = new Set()
        if (Array.isArray(online)) {
          for (const it of online) {
            try { if (it && it.id) ids.add(String(it.id)) } catch(e){}
            try { if (it && it.username) names.add(String(it.username)) } catch(e){}
          }
        }
        setPresence({ ids, names })
      } catch(e){}
    })

    socket.on('presence_update', ({ userId, username, online }) => {
      try {
        setPresence(prev => {
          const ids = new Set(prev.ids || [])
          const names = new Set(prev.names || [])
          if (online) {
            if (userId) ids.add(String(userId))
            if (username) names.add(String(username))
          } else {
            if (userId) ids.delete(String(userId))
            if (username) names.delete(String(username))
          }
          return { ids, names }
        })
      } catch(e){}
    })

    // 🔥 Group event listeners
    socket.on('group_created', (data) => {
      console.log('📢 Group created event:', data)
      fetchGroups()
    })

    socket.on('added_to_group', (data) => {
      console.log('📢 Added to group event:', data)
      fetchGroups()
    })

    socket.on('joined_room', ({ room }) => {
      try {
        if (room) {
          setCurrentRoomId(String(room))
          currentRoomIdRef.current = String(room)
          ;(async () => {
            try {
              const res = await fetchRoomMessages(room, chatTargetRef.current)
              if (res && res.success && Array.isArray(res.messages)) {
                const buf = getBufferedMessagesFor({ roomVal: room, idVal: extractId(chatTargetRef.current), usernameVal: chatTargetRef.current && chatTargetRef.current.username })
                const merged = (res.messages || []).concat(buf).filter((v, i, a) => a.findIndex(x => x.id === v.id) === i)
                setMessages(merged)
                cacheMessagesForRoom(room, merged)
                if (buf && buf.length) setBufferedMessages(prev => { const c = { ...(prev||{}) }; delete c[`room:${String(room)}`]; if (chatTargetRef.current && chatTargetRef.current.username) delete c[`u:${String(chatTargetRef.current.username)}`]; delete c[`id:${String(extractId(chatTargetRef.current))}`]; return c })
              }
            } catch (e) { console.warn('joined_room fetch error', e) }
          })()
        }
      } catch(e){}
    })

    socket.on('receive_message', (m) => {
      try {
        const msg = Object.assign({}, m)
        if (!msg.id) msg.id = `tmp-${Date.now()}-${Math.floor(Math.random()*10000)}`
        if (!msg.room_id && msg.room) msg.room_id = msg.room
        if (!msg.sender_id) msg.sender_id = msg.sender || msg.from_user || msg.user_id || null

        const me = userRef.current || {}
        const meId = extractId(me)
        const currentTarget = chatTargetRef.current
        const currentTargetId = extractId(currentTarget)
        const currentRoom = currentRoomIdRef.current ? String(currentRoomIdRef.current) : null
        const msgRoom = msg.room_id ? String(msg.room_id) : null
        
        let senderNumeric = null
        try {
          if (msg.sender_id && Number.isFinite(Number(msg.sender_id))) senderNumeric = Number(msg.sender_id)
          else if (msg.sender && typeof msg.sender === 'object' && extractId(msg.sender)) senderNumeric = extractId(msg.sender)
          else if (msg.sender_username) {
            const known = (allUsers || []).find(x => String(x.username) === String(msg.sender_username))
            if (known && known.id) senderNumeric = Number(known.id)
          }
        } catch(e){}
        const senderId = senderNumeric ? String(senderNumeric) : (msg.sender_username ? String(msg.sender_username) : null)
        if (senderNumeric) msg.sender_id = senderNumeric

        // 🔥 Check if this is a group message
        const isGroupMessage = currentTarget?.is_group || msgRoom && msgRoom.startsWith('group_')
        
        if (isGroupMessage && msgRoom) {
          // 🔥 Group message handling
          setGroupMessages(prev => ({
            ...prev,
            [msgRoom]: [...(prev[msgRoom] || []), msg]
          }))
          
          if (currentTarget?.is_group && currentTarget?.room_id === msgRoom) {
            setMessages(prev => [...prev, msg])
          }
          
          // Refresh groups to update last message
          fetchGroups()
        } else {
          // 🔥 Private message handling
          const belongsToOpen = (msgRoom && currentRoom && String(msgRoom) === String(currentRoom)) || (currentTargetId && senderId && String(currentTargetId) === String(senderId))

          if (belongsToOpen) {
            setMessages(prev => {
              const base = Array.isArray(prev) ? prev.slice() : []
              if (base.find && base.find(x => String(x.id) === String(msg.id))) return base
              base.push(msg)
              try { base.sort((a,b)=> new Date(a.created_at || 0) - new Date(b.created_at || 0)) } catch(e){}
              try { if (msgRoom) cacheMessagesForRoom(msgRoom, base) } catch(e){}
              return base
            })
          } else {
            const sid = senderId || (msg && msg.sender_username) || 'unknown'
            const roomKeyVal = msgRoom
            setBufferedMessages(prev => {
              const copy = { ...(prev||{}) }
              const idKey = `id:${String(sid)}`
              copy[idKey] = copy[idKey] || []
              if (!copy[idKey].find(x => String(x.id) === String(msg.id))) copy[idKey].push(msg)
              if (roomKeyVal) {
                const rk = `room:${String(roomKeyVal)}`
                copy[rk] = copy[rk] || []
                if (!copy[rk].find(x => String(x.id) === String(msg.id))) copy[rk].push(msg)
              }
              return copy
            })
            if (senderId && String(senderId) !== String(meId)) {
              setUnreadCounts(prev => ({ ...(prev||{}), [String(senderId)]: (prev[String(senderId)]||0) + 1 }))
              try {
                setRecentChats(prev => {
                  const copy = Array.isArray(prev) ? prev.slice() : []
                  const sid = String(senderId)
                  const idx = copy.findIndex(x => String(x.other) === sid || (x.user && String(x.user.id) === sid))
                  const senderObj = (msg.sender && typeof msg.sender === 'object') ? msg.sender : (msg.sender_id ? { id: msg.sender_id, username: msg.sender_username || null, fullname: msg.sender_fullname || null, avatar: msg.sender_avatar || msg.sender_image || null } : { id: Number(senderId), username: msg.sender_username || null, fullname: msg.sender_fullname || null, avatar: msg.sender_avatar || msg.sender_image || null })
                  const senderAvatar = senderObj.avatar || senderObj.image || msg.sender_avatar || msg.avatar || msg.image || null
                  const known = (allUsers || []).find(x => {
                    try {
                      if (!x) return false
                      if (x.id && String(x.id) === String(senderObj.id)) return true
                      if (x.username && senderObj.username && String(x.username) === String(senderObj.username)) return true
                      if (x.staff_id_number && senderObj.username && String(x.staff_id_number) === String(senderObj.username)) return true
                      if (x.fullname && senderObj.fullname && String(x.fullname) === String(senderObj.fullname)) return true
                      return false
                    } catch(e){ return false }
                  })
                  const mergedUser = Object.assign({}, known || {}, senderObj, { avatar: senderAvatar, fullname: senderObj.fullname || (known && (known.fullname || known.name || known.staffname_kh1)) || null })
                  const entry = { room: msg.room_id || null, other: Number(senderId), unread: ( (prev && prev.length && copy[idx] && copy[idx].unread) ? (copy[idx].unread + 1) : ( (Number((prev && prev.length && copy[idx]) ? copy[idx].unread : 0) || 0) + 1 ) ), lastMessagePreview: getPreviewFromMessage(msg), time: msg.created_at || new Date().toISOString(), user: mergedUser }
                  if (idx >= 0) copy.splice(idx, 1)
                  copy.unshift(entry)
                  return copy
                })
              } catch(e){ console.warn('recentChats update error', e) }
            }
          }
        }
        try { loadRooms().catch(()=>{}) } catch(e) {}
      } catch (e) { console.warn('receive_message handler error', e) }
    })

    socket.on('typing', ({ room_id, sender_id }) => {
      try {
        const currentTargetId = extractId(chatTargetRef.current)
        if ((currentTargetId && String(sender_id) === String(currentTargetId)) || (currentRoomIdRef.current && String(room_id) === String(currentRoomIdRef.current))) {
          setTyping(true)
          setTimeout(() => setTyping(false), 1400)
        }
      } catch(e){}
    })

    socket.on('stop_typing', () => setTyping(false))
    socket.on('disconnect', () => console.debug('socket disconnected'))

    return () => { try { socket.disconnect() } catch(e){} }
  }, [SOCKET_URL])

  // 🔥 Send message (supports both private and group)
  const handleSendMessage = async (files) => {
    if (!chatTarget) return
    if (isConverting) return
    
    const text = messageText && messageText.trim()
    if (!text && (!files || !files.length)) return
    
    if (chatTarget.is_group) {
      // 🔥 SEND GROUP MESSAGE
      const result = await sendGroupMessage(chatTarget.room_id, text, files)
      if (result) {
        setMessageText('')
        await fetchGroups()
      }
    } else {
      // 🔥 SEND PRIVATE MESSAGE
      await sendSocketMessage(files)
    }
  }

  async function sendSocketMessage(files, overrideText) {
    if (!chatTarget) return
    if (isConverting) return
    const text = (typeof overrideText === 'string' ? overrideText : (messageText && messageText.trim()))
    if (!text && (!files || !files.length)) return
    try {
      const myUser = userRef.current || getCurrentUser()
      const myId = extractId(myUser)
      const targetId = extractId(chatTarget)
      let roomToUse = null
      try {
        const q = targetId ? `target_id=${String(targetId)}` : `target_username=${encodeURIComponent(String(chatTarget.username||''))}`
        const rv = await request(`messagechat/resolve?${q}`, 'get', {})
        if (rv && rv.success && rv.room) roomToUse = String(rv.room)
      } catch(e){}
      if (!roomToUse) {
        const computed = computeRoomId(myId, targetId)
        if (computed === null) return
        roomToUse = String(computed)
      }
      const payload = { room_id: String(roomToUse), message: text || '', sender_id: myId }
      if (files && Array.isArray(files) && files.length) {
        const convertRemote = async (file) => {
          try {
            const rawToken = localStorage.getItem('token')
            const token = rawToken ? String(rawToken).replace(/^\"|\"$/g, '') : null
            const fd = new FormData()
            fd.append('file', file)
            const url = (base_url || '').replace(/\/$/, '') + '/messagechat/convert'
            const resp = await fetch(url, { method: 'POST', headers: token ? { 'Authorization': 'Bearer ' + token } : {}, body: fd })
            let j = null
            try { j = await resp.json() } catch(e) { const txt = await resp.text().catch(()=>null); console.warn('convertRemote: non-json response', resp.status, txt); }
            if (!resp.ok) {
              console.warn('convertRemote: server responded', resp.status, j)
            }
            if (j && j.success && j.file) return j.file
          } catch (e) { console.warn('remote convert failed', e) }
          return null
        }

        const compressImage = (file, maxWidth = 1280, quality = 0.75) => new Promise((resolve) => {
          try {
            const img = new Image()
            img.onload = () => {
              try {
                const ratio = img.width / img.height
                let w = img.width
                let h = img.height
                if (w > maxWidth) {
                  w = maxWidth
                  h = Math.round(w / ratio)
                }
                const canvas = document.createElement('canvas')
                canvas.width = w
                canvas.height = h
                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, w, h)
                const dataUrl = canvas.toDataURL('image/jpeg', quality)
                const idx = dataUrl.indexOf(',')
                const b64 = idx >= 0 ? dataUrl.slice(idx+1) : dataUrl
                resolve({ data: b64, mimetype: 'image/jpeg', previewUrl: dataUrl })
              } catch (e) { resolve(null) }
            }
            img.onerror = () => resolve(null)
            img.src = URL.createObjectURL(file)
          } catch (e) { resolve(null) }
        })

        const readFileAsBase64 = async (file) => {
          try {
            const name = (file && file.name) ? String(file.name).toLowerCase() : ''
            const isHeic = (file && file.type && String(file.type).toLowerCase().includes('heic')) || name.endsWith('.heic') || name.endsWith('.heif')
            let preview = null
            try { preview = URL.createObjectURL(file) } catch(e) { preview = null }
            if (isHeic) {
              try {
                const convertedBlob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.8 })
                const dataUrl = await new Promise((resolve, reject) => {
                  const fr = new FileReader()
                  fr.onload = () => resolve(fr.result)
                  fr.onerror = reject
                  fr.readAsDataURL(convertedBlob)
                })
                const idx = String(dataUrl).indexOf(',')
                const b64 = idx >= 0 ? String(dataUrl).slice(idx+1) : String(dataUrl)
                return { originalname: file.name.replace(/\.(heic|heif)$/i, '.jpg'), mimetype: 'image/jpeg', data: b64, previewUrl: dataUrl }
              } catch (e) {
                console.warn('heic2any convert failed, falling back to server convert', e)
                const remote = await convertRemote(file)
                if (remote && remote.base64) {
                  const mim = remote.mime || 'image/jpeg'
                  const b64 = remote.base64
                  const dataUrl = remote.url ? (remote.url.startsWith('http') ? remote.url : ((base_url||'').replace(/\/$/,'') + remote.url)) : (mim && mim.startsWith('image/') ? `data:${mim};base64,${b64}` : null)
                  return { originalname: remote.originalName || file.name, mimetype: mim, data: b64, previewUrl: dataUrl }
                }
              }
            }
            if (file && file.type && String(file.type).startsWith('image/') && !isHeic) {
              const compressed = await compressImage(file)
              if (compressed && compressed.data) {
                return { originalname: file.name, mimetype: compressed.mimetype || file.type || '', data: compressed.data, previewUrl: compressed.previewUrl || preview }
              }
            }
            return await new Promise((resolve, reject) => {
              try {
                const reader = new FileReader()
                reader.onload = () => {
                  const result = reader.result || ''
                  const idx = String(result).indexOf(',')
                  const b64 = idx >= 0 ? String(result).slice(idx+1) : String(result)
                  resolve({ originalname: file.name, mimetype: file.type || '', data: b64, previewUrl: preview })
                }
                reader.onerror = (e) => reject(e)
                reader.readAsDataURL(file)
              } catch (e) { reject(e) }
            })
          } catch (e) { return { originalname: file.name, mimetype: file.type || '', data: '', previewUrl: null } }
        }
        const attaches = []
        for (const f of files) {
          try {
            const out = await readFileAsBase64(f)
            attaches.push(out)
          } catch(e) { console.warn('file read failed', e) }
        }
        if (attaches.length) payload.attachments = attaches
      }

      socketRef.current && socketRef.current.emit('send_message', payload)
      try { await loadRooms() } catch(e) { console.warn('loadRooms after send failed', e) }
      let localSaved = null
      try {
        const tmpId = `tmp-${Date.now()}-${Math.floor(Math.random()*10000)}`
        const now = new Date().toISOString()
        localSaved = { id: tmpId, room_id: String(roomToUse), sender_id: myId, created_at: now }
        if (payload && Array.isArray(payload.attachments) && payload.attachments.length) {
          const localFiles = []
          for (let i = 0; i < payload.attachments.length; i++) {
            const a = payload.attachments[i]
            const originalName = a.originalname || a.filename || (`file_${i}`)
            const mime = a.mimetype || a.mime || a.type || ''
            const url = a.previewUrl || (a.data ? `data:${mime};base64,${a.data}` : null)
            localFiles.push({ originalName, filename: a.filename || originalName, mime, url })
          }
          localSaved.type = 'image'
          localSaved.message = JSON.stringify({ files: localFiles, caption: payload.message || '' })
          localSaved.sender_username = myUser && myUser.username ? myUser.username : null
          localSaved.sender_fullname = myUser && (myUser.fullname || myUser.staffname_kh1 || myUser.name) ? (myUser.fullname || myUser.staffname_kh1 || myUser.name) : null
          localSaved.sender_avatar = myUser && (myUser.avatar || myUser.image) ? (myUser.avatar || myUser.image) : null
        } else {
          localSaved.type = 'text'
          localSaved.message = payload.message || ''
          localSaved.sender_username = myUser && myUser.username ? myUser.username : null
          localSaved.sender_fullname = myUser && (myUser.fullname || myUser.staffname_kh1 || myUser.name) ? (myUser.fullname || myUser.staffname_kh1 || myUser.name) : null
          localSaved.sender_avatar = myUser && (myUser.avatar || myUser.image) ? (myUser.avatar || myUser.image) : null
        }
        setMessages(prev => {
          const p = prev && Array.isArray(prev) ? prev : []
          const next = [...p, localSaved]
          try { cacheMessagesForRoom(String(roomToUse), next) } catch(e){}
          return next
        })
      } catch(e) {
        try { console.warn('local append error', e) } catch(_){}
      }
      try {
        setRecentChats(prev => {
          const copy = Array.isArray(prev) ? prev.slice() : []
          const uid = String(targetId)
          const idx = copy.findIndex(x => String(x.other) === uid || (x.user && String(x.user.id) === uid))
          const known = (allUsers || []).find(x => String(x.id) === uid || String(x.username) === String((chatTarget && chatTarget.username) || ''))
          const baseUser = chatTarget || {}
          const avatar = baseUser.avatar || baseUser.image || (known && known.avatar) || null
          const fullname = baseUser.fullname || (known && (known.fullname || known.name || known.staffname_kh1)) || null
          const entry = idx >= 0 ? copy[idx] : { room: String(roomToUse), other: Number(uid), unread: 0, lastMessagePreview: messageText || '', time: new Date().toISOString(), user: Object.assign({}, known || {}, baseUser, { avatar, fullname }) }
          entry.lastMessagePreview = getPreviewFromMessage(localSaved) || (messageText || '')
          entry.time = new Date().toISOString()
          entry.unread = 0
          if (idx >= 0) copy.splice(idx,1)
          copy.unshift(entry)
          return copy
        })
      } catch(e) { console.warn('sendSocketMessage recentChats update error', e) }
      setMessageText('')
    } catch(e) { console.error('sendSocketMessage error', e) }
    finally {
      try { if (isConverting) setIsConverting(false) } catch(_){}
    }
  }

  function handleTypingInput(val) {
    try {
      const text = val || ''
      const socket = socketRef.current
      const room = currentRoomIdRef.current ? String(currentRoomIdRef.current) : null
      const me = userRef.current || {}
      const meId = extractId(me)
      if (!socket) return
      if (text && String(text).trim().length > 0) {
        socket.emit('typing', { room_id: room, sender_id: meId })
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current)
        typingTimeoutRef.current = setTimeout(() => {
          try { socket.emit('stop_typing', { room_id: room, sender_id: meId }) } catch(e){}
        }, 1400)
      } else {
        try { socket.emit('stop_typing', { room_id: room, sender_id: meId }) } catch(e){}
        if (typingTimeoutRef.current) { clearTimeout(typingTimeoutRef.current); typingTimeoutRef.current = null }
      }
    } catch(e) { console.warn('handleTypingInput error', e) }
  }

  function handleLogout() { try { localStorage.removeItem('token') } catch(e){} window.location.href = '/login' }

  useEffect(() => { if (!messagesEndRef.current) return; messagesEndRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' }) }, [messages])

  useEffect(() => {
    const check = () => {
      try { setIsMobile(typeof window !== 'undefined' && window.innerWidth <= 720) } catch(e) { setIsMobile(false) }
    }
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  const convertRemote = async (file) => {
    try {
      const rawToken = localStorage.getItem('token')
      const token = rawToken ? String(rawToken).replace(/^"|"$/g, '') : null
      const fd = new FormData()
      fd.append('file', file)
      const url = (base_url || '').replace(/\/$/, '') + '/messagechat/convert'
      const resp = await fetch(url, { method: 'POST', headers: token ? { 'Authorization': 'Bearer ' + token } : {}, body: fd })
      let j = null
      try { j = await resp.json() } catch(e) { const txt = await resp.text().catch(()=>null); console.warn('convertRemote: non-json response', resp.status, txt); }
      if (!resp.ok) {
        console.warn('convertRemote: server responded', resp.status, j)
      }
      if (j && j.success && j.file) return j.file
    } catch (e) { console.warn('remote convert failed', e) }
    return null
  }

  const prepareFiles = async (files) => {
    if (!files || !files.length) return []
    setIsConverting(true)
    const out = []
    try {
      for (const f of files) {
        try {
          const name = (f && f.name) ? String(f.name).toLowerCase() : ''
          const isHeic = (f && f.type && String(f.type).toLowerCase().includes('heic')) || name.endsWith('.heic') || name.endsWith('.heif')
          if (isHeic) {
            try {
              const conv = await heic2any({ blob: f, toType: 'image/jpeg', quality: 0.8 })
              const blob = (conv && conv.length && conv[0]) ? conv[0] : conv
              const newName = (f.name || '').replace(/\.(heic|heif)$/i, '.jpg')
              const newFile = new File([blob], newName, { type: 'image/jpeg' })
              const preview = URL.createObjectURL(newFile)
              out.push({ file: newFile, preview })
              continue
            } catch (e) {
              console.warn('prepareFiles: heic2any failed, trying server convert', e)
              const remote = await convertRemote(f)
              if (remote && remote.base64) {
                const mim = remote.mime || 'image/jpeg'
                const b64 = remote.base64
                const dataUrl = remote.url ? (remote.url.startsWith('http') ? remote.url : ((base_url||'').replace(/\/$/,'') + remote.url)) : (mim && mim.startsWith('image/') ? `data:${mim};base64,${b64}` : null)
                try {
                  const res = await fetch(dataUrl)
                  const blob = await res.blob()
                  const newName = (f.name || '').replace(/\.(heic|heif)$/i, '.jpg')
                  const newFile = new File([blob], newName, { type: mim })
                  const preview = dataUrl
                  out.push({ file: newFile, preview })
                  continue
                } catch (er) {
                  console.warn('prepareFiles: failed to create blob from remote base64', er)
                }
              }
            }
          }
          const preview = f.type && f.type.startsWith('image/') ? URL.createObjectURL(f) : null
          out.push({ file: f, preview })
        } catch (e) { console.warn('prepareFiles: file processing failed', e); const preview = f && f.type && f.type.startsWith('image/') ? URL.createObjectURL(f) : null; out.push({ file: f, preview }) }
      }
    } finally {
      setIsConverting(false)
    }
    return out
  }

  // 🔥 Get current messages based on chat type
  const getCurrentMessages = () => {
    if (chatTarget?.is_group) {
      return groupMessages[chatTarget.room_id] || []
    }
    return messages
  }

  // 🔥 Fetch groups on mount
  useEffect(() => {
    fetchGroups()
    loadRooms()
  }, [])

  return (
    <div style={{ flex: 1, height: isMobile ? '75vh' : '100%', display: 'flex', flexDirection: 'column' }}>
      <div className="mobile-search" style={{ padding: '8px' }}>
        <input className="search-input" placeholder="ស្វែងរកឈ្មោះបុគ្គលិក...." allowClear value={mobileSearchQuery} onChange={(e) => setMobileSearchQuery(e.target.value)} />
      </div>
      <div className="message-chat-root" style={{ display: 'flex', height: '100%' }}>
        <div style={{ width: (isMobile ? 70 : 320), borderRight: '1px solid #eee' }}>
          {isMobile ? (
          <SidebarChat 
    user={user} 
    allUsers={allUsers} 
    chatTarget={chatTarget} 
    unreadCounts={{...unreadCounts, ...groupUnreadCounts}} 
    recentChats={recentChats}  // ✅ Make sure this is passed
    groups={groups}            // ✅ Make sure this is passed
    onChat={handleChatSelect}
    onLogout={handleLogout} 
    presence={presence} 
    search={mobileSearchQuery} 
    onSearchChange={setMobileSearchQuery} 
/>
          ) : (
           <SidebarChat 
    user={user} 
    allUsers={allUsers} 
    chatTarget={chatTarget} 
    unreadCounts={{...unreadCounts, ...groupUnreadCounts}} 
    recentChats={recentChats}  // ✅ Make sure this is passed
    groups={groups}            // ✅ Make sure this is passed
    onChat={handleChatSelect}
    onLogout={handleLogout} 
    presence={presence} 
    search={mobileSearchQuery} 
    onSearchChange={setMobileSearchQuery} 
/>
          )}
        </div>
        <div style={{ flex: 1, width: (isMobile ? 70 : '100%'), height: (isMobile ? '75vh' : '100%') }}>
          <ChatWindow 
            chatTarget={chatTarget} 
            messages={getCurrentMessages()}
            user={user} 
            messageText={messageText} 
            setMessageText={(v) => { 
              setMessageText(v); 
              handleTypingInput(v) 
            }} 
            onSend={handleSendMessage}
            messagesEndRef={messagesEndRef} 
            typing={typing} 
            presence={presence} 
            isConverting={isConverting} 
            onPrepareFiles={prepareFiles} 
          />
        </div>
      </div>
    </div>
  )
}